import { useFcm } from './fcm';
import { usePetitionDetails } from './petitionDetails';

export function useCaptchaEnabled(): boolean {
	const { requireHumanVerification } = usePetitionDetails();
	const fcm = useFcm();

	return fcm.captchaEnabled && requireHumanVerification;
}
